import getWithToken from './base/get-with-token'

const getCustomerConsumptionQuarterlyUsage = id => getWithToken(`/customer/${id}/quarterly-data`)

export default getCustomerConsumptionQuarterlyUsage
